export class StringFormatConstants {
    static dateFormat = 'MM/dd/yyyy';
    static dateTimeFormat = 'MM/dd/yyyy hh:mm:ss a'; // 12 hour clock
    static momentDateFormat = 'MM/DD/YYYY';
    static momentDateTimeFormat = 'MM/DD/YYYY hh:mm:ss A'; // 12 hour clock
    static momentLogsDateTimeFormat = 'MM/DD/YYYY hh:mm A'; // 12 hour clock
    static currencyFormat = '$#,##0.00;($#,##0.00)';
    static percentFormat = '#0.00%;(#0.00%)';
    static currencyEditorFormat = '$#,##0.00;($#,##0.00)';
    static timeFormat = 'h:mm a';
    static currencyPrecision = 2;
    static phoneMask = '(X00) 000-0000';
    static momentISOFormat = 'YYYY-MM-DD';
    static numberFormat = '#,##0.00;(#,##0.00)';
    static countFormat = '#,##0;(#,##0)';
    static timeFormat24Hrs = 'HH:mm:ss';
    static momentDateTime24HrsFormat = 'MM/DD/YYYY HH:mm:ss'; // 24 hour clock
    static dateTimeWithoutSecondsFormat = 'MM/dd/yyyy hh:mm a'; // 12 hour clock
    static momentISODateTimeFormat = 'YYYY-MM-DDTHH:mm:ss';
}
